export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const chipsRowStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '4px',
};
